<template>
  <section class="user">
    <header>
      <mo-pageheader>
        <template slot="title">{{ $t('title.param') }}</template>
        <template slot="action">
          <div class="buttons-container flex flex-end">
            <ba-button type="button" class="primary" @click.native="$router.go(-1)">{{ $t('action.return') }}</ba-button>
            <ba-button class="primary" @click.native="handleUpdateUser" >{{ $t('action.save') }}</ba-button>
          </div>
        </template>
      </mo-pageheader>
    </header>
    <main>

     <!-- TABS -->
        <div class="tabs-ctn flex flex-center tabs-margin">
          <div class="tab" v-if="accessAdherent"
            @click="clickOnglet(1)"
            >{{ $t('sectionTitle.adherents') }}
          </div>
          <div class="tab" v-if="accessCompany"
            @click="clickOnglet(2)"
            >{{ $t('sectionTitle.compagnies') }}
          </div>
          <div class="tab active" v-if="accessUser"
            @click="clickOnglet(3)"
            >{{ $t('sectionTitle.utilisateurs') }}
          </div>
          <div class="tab" v-if="accessDroits"
            @click="clickOnglet(4)"
            >{{ $t('sectionTitle.droits') }}
          </div>
        </div>

        <div class="user-security-container flex-stretch flex-space" >
          <!-- USER SECTION -->
          <ba-card>
            <template slot="header">
              <span>{{ $t('sectionTitle.useraccount') }}</span>
            </template>
            <template>
              <div class="profile-card">
                <div class="img-ctn cols">
                  <!-- Drag & drop section -->
                  <div class="filepond--img">
                    <img :src="handleGetUserImage(user.image_path)" @error='defaultImage' v-if="user.image_path != null" />   
                  </div>
                  <div class="height-filepond">
                    <form
                      enctype="multipart/form-data"
                      @submit.prevent="uploadFile"
                    >
                      <file-pond
                        ref="pond"
                        name="pond"
                        style="background: #fff; width: 300px"
                        :label-idle="attachedFile.pondLabel"
                        :allow-multiple="false"
                        :max-file-size="attachedFile.maxFileSizeTrunc"
                        :label-file-type-not-allowed="'Fichier invalide'"
                        :file-validate-type-label-expected-types="''"
                        :label-max-file-size-exceeded="'Le fichier est trop lourd'"
                        :label-max-file-size="`La taille d'un fichier doit être de ${attachedFile.maxFileSizeTrunc} maximum`"
                        :allow-file-type-validation="true"
                        :accepted-file-types="attachedFile.pondAcceptedFileType"
                      />
                    </form>
                  </div>
                </div>
                <div class="cols inputs">
                  <div class="col-2">
                    <ba-select label="Sociétè" v-model="user.company_id">
                      <option :value="company.id" v-for="company in pallcompany" >
                        {{ company.name }}
                      </option>
                    </ba-select>
                  </div>
                  <div class="col-2 more">
                    <div class="tooltip-container alig-span" v-if="user.authorized == '1'">
                      <span class="item" @click="user.authorized = 0">
                        <ab-icon icon="validate" class="validate" iconset="paramgeneral" >
                        </ab-icon>
                      </span>
                      <div class="tooltip">
                        {{ $t('action.deactivate') }}
                      </div>
                      <span>Compte activé</span>
                    </div>
                    <div class="tooltip-container alig-span" v-else>
                      <span class="item" @click="user.authorized = 1">
                        <ab-icon icon="unValidate" class="unValidate" iconset="paramgeneral">
                        </ab-icon>
                      </span>
                      <div class="tooltip">
                        {{ $t('action.activate') }}
                        </div>
                      <span>Compte désactivé</span>
                      </span>                  
                    </div>
                  </div>
                  <div class="col-0">
                    <span class="bar"></span>
                  </div>                
                  <div class="cols">
                    <div class="col-2">
                      <ba-select label="Civilité" v-model="user.civility_id">
                        <option :value="civility.id" v-for="civility in civilities" :key="civility.id">{{ civility.code }}</option>
                      </ba-select>
                    </div>
                    <div class="col-2">
                      <ba-input type="text" label="Email" v-model="user.email">
                      </ba-input>
                    </div>
                    <div class="col-2">
                      <ba-input type="text" label="Nom" v-model="user.last_name">
                      </ba-input>
                    </div>
                    <div class="col-2">
                      <ba-input type="text" label="Tél" v-model="user.phone">
                      </ba-input>
                    </div> 
                    <div class="col-2">
                      <ba-input type="text" label="Prénom" v-model="user.first_name">
                      </ba-input>
                    </div> 
                  </div>
                </div> 
              </div>
            </template>
          </ba-card>

          <ba-card>
            <template slot="header">
              <span>{{ $t('sectionTitle.rolesecurity') }}</span>
            </template>
            <template>
              <div class="profile-card">
                <div class="cols">
                  <div class="col-0">
                    <ba-input 
                    v-model.trim="password.new_pwd"
                    type="password"
                    class="mandatory"
                    label="Mot de passe">
                    </ba-input>
                  </div>
                  <div class="col-0">
                    <ba-input 
                    v-model.trim="password.confirm_pwd"
                    type="password"
                    class="mandatory"
                     label="Confirmation de mot de passe">
                    </ba-input>
                  </div>
                </div>
              </div>
              <span class="bar"></span>
              <div class="profile-card">

                <div class="cols">
                  <div class="col-2" @click="flipFlop(1)">
                    <ba-checkbox v-model="userRole[1]">
                      Administrateur
                    </ba-checkbox>
                  </div>
                  <div class="col-2" @click="flipFlop(4)">
                    <ba-checkbox v-model="userRole[4]">
                      Stocker
                    </ba-checkbox>
                  </div>
                  <div class="col-2" @click="flipFlop(2)">
                    <ba-checkbox v-model="userRole[2]">
                      Manager
                    </ba-checkbox>
                  </div>                  
                  <div class="col-2" @click="flipFlop(3)">
                    <ba-checkbox v-model="userRole[3]">
                      Vendeur
                    </ba-checkbox>
                  </div>
                  <div class="col-2" @click="flipFlop(5)">
                    <ba-checkbox v-model="userRole[5]">
                      Visiteur
                    </ba-checkbox>
                  </div>
                  <div class="col-2" @click="flipFlop(6)">
                    <ba-checkbox v-model="userRole[6]">
                      Partenaire
                    </ba-checkbox>
                  </div>
                </div>
              </div>                    
            </template>

          </ba-card>
        </div>
        <div class="buttons-container flex flex-end" >
          <ba-button class="primary" @click.native="handleUpdateUser">
            {{ $t('action.save') }}
          </ba-button>
        </div>
    </main>

    <ab-iconset iconset="paramgeneral">
      <g id="camera">
        <path d="M5.5 7.33333C6.47202 7.33333 7.26 6.5374 7.26 5.55556C7.26 4.57372 6.47202 3.77778 5.5 3.77778C4.52798 3.77778 3.74 4.57372 3.74 5.55556C3.74 6.5374 4.52798 7.33333 5.5 7.33333Z" fill="white"/>
        <path d="M3.85 0L2.8435 1.11111H1.1C0.495 1.11111 0 1.61111 0 2.22222V8.88889C0 9.5 0.495 10 1.1 10H9.9C10.505 10 11 9.5 11 8.88889V2.22222C11 1.61111 10.505 1.11111 9.9 1.11111H8.1565L7.15 0H3.85ZM5.5 8.33333C3.982 8.33333 2.75 7.08889 2.75 5.55556C2.75 4.02222 3.982 2.77778 5.5 2.77778C7.018 2.77778 8.25 4.02222 8.25 5.55556C8.25 7.08889 7.018 8.33333 5.5 8.33333Z" fill="white" />
      </g>    
      <g id="unValidate">
        <path d="M17.6484 5.64844H6.35153C2.84926 5.64844 0 8.49779 0 12C0 15.5022 2.84926 18.3516 6.35153 18.3516H17.6484C21.1507 18.3516 24 15.5023 24 12C24 8.49774 21.1507 5.64844 17.6484 5.64844ZM6.35153 16.9454C3.62466 16.9454 1.40625 14.7269 1.40625 12C1.40625 9.27315 3.62466 7.05469 6.35153 7.05469C9.07839 7.05469 11.2969 9.27315 11.2969 12C11.2969 14.7269 9.07839 16.9454 6.35153 16.9454Z" />
      </g>
      <g id="validate">
        <path d="M17.6484 5.64844H6.35156C2.8493 5.64844 0 8.49773 0 12C0 15.5023 2.8493 18.3516 6.35156 18.3516H17.6484C21.1507 18.3516 24 15.5023 24 12C24 8.49773 21.1507 5.64844 17.6484 5.64844ZM17.6484 16.9453C14.9216 16.9453 12.7031 14.7269 12.7031 12C12.7031 9.27319 14.9216 7.05469 17.6484 7.05469C20.3753 7.05469 22.5938 9.27319 22.5938 12C22.5938 14.7269 20.3753 16.9453 17.6484 16.9453Z" />
      </g>
    </ab-iconset>
  </section>
</template>

<script>
import { AbIcon, AbIconset, BaButton, BaCard, BaCheckbox, BaDropdownInput, BaInput, BaSelect } from '@ab/basic-components';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';

import { mapState } from 'vuex';

import {fr} from "vuejs-datepicker/dist/locale";

import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

const FilePond = vueFilePond(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

export default {
  name: 'UserEdit',
  components: {
    AbIcon,
    AbIconset,
    BaButton,
    BaCard,
    BaCheckbox,
    BaDropdownInput,
    BaInput,
    BaSelect,
    MoPageheader,
    FilePond
  },
  computed: {
    ...mapState({ civilities: state => state.users.civilities }),
    ...mapState({ pallcompany: state => state.company.pallcompany })
  },  
  async mounted() {
    this.accessAdherent = await this.$store.dispatch('getAccesRole', {search:29,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessCompany = await this.$store.dispatch('getAccesRole', {search:30,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessUser = await this.$store.dispatch('getAccesRole', {search:31,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessDroits = await this.$store.dispatch('getAccesRole', {search:32,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});  

    const id = this.$route.params.id;
    if(id != null) {
      this.user = await this.$store.dispatch('getParamUsers',{ id: id });
      if (this.user.id == '') {
        this.$store.dispatch('displaySnackbar', { text: `L'utilisateur n'a pas été trouvé`, mode: 'error' });
        return this.$router.go(-1);
      }  
    }
  //  let userRoleBdd = await this.$store.dispatch('getParamRoleUsers',{ id: id });

    let val = ''
    if(this.user.role_id != null){
      this.$set(this.userRole, this.user.role_id, true)
    }
  
    await this.$store.dispatch('getCivilities')
    await this.$store.dispatch('getParamAllCompany');   
    this.$store.dispatch('setLoading', false);
    this.$store.commit('setSpinner', false);

  },
  data() {
    return {
      accessAdherent: false,
      accessCompany: false,
      accessUser: false,
      accessDroits: false,    
      fileStatus: '',
      isFileUploadOngoing: '',
      fileLoading: '',
      files: '',
      fr,
      attachedFile: {
        fileId: null,
        fileStatus: '',
        maxFileSize: 10000000,
        maxFileSizeTrunc: '10 MB',
        pondLabel: 'Glissez votre fichier ou <u>cliquez ici</u> format JPG, PNG, GIF',
        pondAcceptedFileType: [ 'image/jpeg', 'image/png', 'image/gif' ],
        currentPage: 1,
        searchLimit: 5,
        resultatImport: null
      },
      profile: '',
        user: {
            id: '',
            first_name: '',
            last_name: '',  
            phone: '',                
            email: '',
            civility_id: '',
            company_id: '',
            authorized: 0
        },
        password: {
          new_pwd: '',
          confirm_pwd: '',
        },
        userRole: [false,false,false,false,false,false,false]
    }
  },
  methods: {
    clickOnglet(x) {
      switch (x) {
        case 1:
          this.$router.push('/param/adherents')
          break;
        case 2:
          this.$router.push('/param/companies')
          break;
        case 3:
          this.$router.push('/param/users')
          break;
        case 4:
          this.$router.push('/param/droits')
          break;                    
        case 5:
          this.$router.push('/param/consignes');
          break;
        default:
      }
    },
    flipFlop(x){
      for (let i = 0; i < this.userRole.length; i++) {
        this.userRole[i] = false
      }

      switch (x) {
        case '1':
          this.userRole[1] = true
          break;
        case '2':
          this.userRole[2] = true
          break;          
        case '3':
          this.userRole[3] = true
          break;
        case '4':
          this.userRole[4] = true
          break;
        case '5':
          this.userRole[5] = true
          break;          
      }
    },
    // Handle modal
    beforeOpen(e) {
      this.removeModal.id = e.params.id;
      this.removeModal.label = e.params.label;
      this.removeModal.type = e.params.type;
    },
    /* Image for error case */
    defaultImage(e) {
      e.target.src = 'https://cdn.activcar.fr/media/64/brands/default.png';
    },    
    /* Get brand image */
    handleGetUserImage(imgName) {
      const baseApi = process.env.VUE_APP_ROOT_API;
      return `${baseApi}/upload/user/${imgName}`;
    },    
    async handleUpdateUser(redirect = true) {

      if (this.password.new_pwd != '' || this.password.confirm_pwd != '') {
        // If new password & confirmation don't have same value
        if (this.password.new_pwd !== this.password.confirm_pwd) {
          return this.$store.dispatch('displaySnackbar', { text: 'Le nouveau mot de passe et la confirmation ne sont pas identiques', mode: 'error' });
        }

        if (!this.password.new_pwd.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+=.;_{}<>|^£:"'])[A-Za-z\d@$!%*#?&+=.;_{}<>|^£:"']{8,}$/) || !this.password.confirm_pwd.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+=.;_{}<>|^£:"'])[A-Za-z\d@$!%*#?&+=.;_{}<>|^£:"']{8,}$/)) {
          return this.$store.dispatch('displaySnackbar', { text: "Votre mot de passe doit contenir au moins 8 caractères dont 1 lettre 1 chiffre et 1 caractère spécial", mode: 'error' });
        }
      }

      if(this.user.first_name.trim() == '' || this.user.last_name.trim()  == '' || this.user.email.trim() == '' || this.user.company_id == '') {
        return this.$store.dispatch('displaySnackbar', { text: `Le nom, prénom, email, Socièté, rôle sont obligatoires`, mode: 'error' });        
      }

      this.$store.dispatch('setLoading', true);

      let flag = 0
      for (let i = 0; i < this.userRole.length; i++) {
        if(this.userRole[i] == true){
          this.user.role_id = i
          flag = 1
        }
      }      

      if(flag == 0) {
        return this.$store.dispatch('displaySnackbar', { text: `L'attribution d'un role est obligatoire`, mode: 'error' });
      }

      if(this.$route.params.id == '' || this.$route.params.id == null) {
        const formData = new FormData();
        if (this.$refs.pond.getFile() != null) {
          if (this.$refs.pond.getFile().fileSize > this.attachedFile.maxFileSize) {
            return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter une image dont la taille de dépasse pas ${this.attachedFile.maxFileSizeTrunc}`, mode: 'error' });
          }
          // Check file type
          const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
          if (typeof fileType === 'undefined') {
            return this.$store.dispatch('displaySnackbar', { text: 'Veuillez sélectionner une image ayant un format valide', mode: 'error' });
          }
          const { file } = this.$refs.pond.getFile();
          formData.append('fileUpload', file, file.name);
        }

        const data = await this.$store.dispatch('createParamUser', {
          id: '',
          last_name: this.user.last_name,
          first_name: this.user.first_name, 
          phone: this.user.phone,
          email: this.user.email,
          civility_id: this.user.civility_id,           
          company_id: this.user.company_id,
          authorized: this.user.authorized,
          password: this.password.new_pwd.replaceAll('?', '‰‰'),
          passwordconfirm: this.password.confirm_pwd.replaceAll('?', '‰‰'),     
          userRole:this.user.role_id,
          data: formData,
        });
        this.$store.commit('setSpinner', false);
        if (data) {
          this.$store.dispatch('displaySnackbar', { text: "L'utilisateur à bien été crée" });
          if (redirect) this.$router.go(-1);
        }  
      } else {
        const formData = new FormData();
        if (this.$refs.pond.getFile() != null) {
          if (this.$refs.pond.getFile().fileSize > this.attachedFile.maxFileSize) {
            return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter une image dont la taille de dépasse pas ${this.attachedFile.maxFileSizeTrunc}`, mode: 'error' });
          }
          // Check file type
          const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
          if (typeof fileType === 'undefined') {
            return this.$store.dispatch('displaySnackbar', { text: 'Veuillez sélectionner une image ayant un format valide', mode: 'error' });
          }
          const { file } = this.$refs.pond.getFile();
          formData.append('fileUpload', file, file.name);
        }

        const data = await this.$store.dispatch('updateParamUser', {
          id: this.user.id,
          last_name: this.user.last_name,
          first_name: this.user.first_name, 
          phone: this.user.phone,
          email: this.user.email,
          civility_id: this.user.civility_id,           
          company_id: this.user.company_id,
          authorized: this.user.authorized,
          password: this.password.new_pwd.replaceAll('?', '‰‰'),
          passwordconfirm: this.password.confirm_pwd.replaceAll('?', '‰‰'),
          userRole:this.user.role_id,
          data: formData,
        });
        this.$store.commit('setSpinner', false);
        if (data) {
          if(data.flag) {
            if(data.flag == 'email_exist') {
              this.$store.dispatch('displaySnackbar', { text: 'Cet email existe déjà', mode: 'error' });
              return
            }
          }
          this.$store.dispatch('displaySnackbar', { text: "L'utilisateur à bien été modifié" });
          if (redirect) this.$router.go(-1);
        }  
      }
      this.$store.commit('setSpinner', false);
    },
  },
};
</script>
<style scoped>
/* Image */
/*.user .img-container {
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 50%;
  overflow: hidden;
}
.user .img-container img {
  min-width: 100%;
}*/

/* -- Profile -- */
.user .personal-info-card { margin-top: 2rem; }
.user .profile-card {
  display: flex;
  align-items: start;
  padding-top: 2rem;
}
/* Image */
.img-ctn > img {
  position: relative;
  width: 120px;
  height: 120px;
  border: none;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 1rem;
  cursor: pointer;
}
/*.user .profile .img-ctn img { width: 100%; }*/
.user .profile .img-picture {
  position: absolute;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000;
  opacity: 0.5;
}
/* Form display */
.user .profile .inputs { flex: 1; padding-top: 0;}

/* -- Subscription -- */
/* Inputs */
.user .subscription .input-ctn { padding: 0 0 2rem 3rem; }
.user .subscription .subscription-part { margin-top: 3rem; text-align: center; }
.user .subscription .title { font-size: 1.3rem; }
.user .subscription .input-label { margin-top: 2rem; }
.user .subscription .input-label .label { margin-right: 2rem; font-size: 0.79rem; }
/* Information card */
.user .subscription .info-ctn {
  padding: 0 3rem 2rem 4rem;
}
.user .subscription .info-card {
  padding: 1.5rem 2.5rem 2.5rem 2.5rem;
  background-color: var(--app-lightgrey-2-color);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  font-size: 0.79rem;
}
.user .subscription .info-card ul { padding: 0; }
.user .subscription .info-card:last-child { margin-top: 6.3rem; }
.user .subscription .info-card .space { margin-top: 1rem; }

/* -- Payment method -- */
.user .payment .input-ctn { padding: 0 2rem 2rem 2rem; }
.user .payment .input-ctn p { margin-left: 1rem; }
.user .payment .col-1 {
  padding: 0 1rem;
  padding-bottom: 1.5rem;
}
.user .payment .underline { text-decoration: underline; }

/* Main title for subscription & payment sections */
.user .subscription .main-title,
.user .payment .main-title {
  margin: 1rem 0 0 3rem;
  font-size: 1.3rem;
}

/* Button on card footer */
.user .buttons-container { padding: 0 1rem 1rem 1rem; }

.user .profile-card {
  padding-top: 0px;
}

/* Color icons */
.more .unValidate {
  color: var(--ba-state-pending-bg-color, rgb(249, 180, 0));
}

.more .validate {
  color: var(--ba-button-bg-secondary-hover, rgb(20, 141, 160));
}

.more .validate,
.more .unValidate {
  height: 40px;
  width: 40px;
}
.ba-card .col-3 section, .ba-card .col-2 section.ba-checkbox {
  padding-bottom: 1rem;
}
.flex-end {
  padding-right: 0px!important;
  padding-top: 1rem!important;
}
.tabs-ctn {
  margin-bottom: 2rem;
}
.alig-span {
  display: flex;
  align-items: center;
  margin-top: -7px;
}
.tooltip {
  top: 25px;
}

/* filepond */
.filepond--img {
  border-radius: 50%;
  height: 200px;
  overflow: hidden;
  width: 200px;
}

.filepond--img img {
  height: auto;
  width: 100%;
}

.img-ctn {
justify-content: center;
  position: relative;
} 
</style>
<style src="@/assets/styles/tabs.css"></style>
<style src="@/assets/styles/requests.css"></style>
<style src="@/assets/styles/tooltips.css"></style>
